export enum DriverAckType {
  CONFIRMATION = 'CONFIRMATION',
  ACCEPT_REJECT = 'ACCEPT_REJECT',
  ACK_DISABLED = 'ACK_DISABLED',
}

export enum OwnerOperatorDriverAckType {
  CONFIRMATION = 'CONFIRMATION',
  ACCEPT_REJECT = 'ACCEPT_REJECT',
  ACK_DISABLED = 'ACK_DISABLED',
}

export interface TenantDriverSettings {
  id: string;
  tenant_id: string;
  company_driver_ack_type: DriverAckType;
  owner_operator_driver_ack_type: OwnerOperatorDriverAckType;
}

export type TenantDriverSettingsFormValues = Pick<TenantDriverSettings, 'company_driver_ack_type' | 'owner_operator_driver_ack_type'>;
